<div class="wrap-tost" *ngIf="tost">
    <div class="type error" *ngIf="tost.type==enumTypeTost.ERROR">
        <img src="/assets/images/x.svg" />
    </div>
    <div class="type success" *ngIf="tost.type==enumTypeTost.SUCCESS">
        <img src="/assets/images/v-ok.svg" />
    </div>
    <div class="type load" *ngIf="tost.type==enumTypeTost.LOAD">
        <img src="/assets/images/load-tost.svg" />
    </div>
    <div class="message" translate [translateParams]="{message:tost!.message}">tost.message</div>
    <div class="X" (click)="deleteTost()">
        <img src="/assets/images/mini-x.svg" />
    </div>
</div>